/* eslint-disable max-len */
const laRubriquePosts = require('./json/laRubriquePosts/index');
const laRubriqueCategories = require('./json/laRubriqueCategories.json');
const landings = require('./json/landingsPartners.json');
const localitiesLandings = require('./json/landingsLocalities.json');
const localitiesLeatherGoodsLandings = require('./json/landingsLocalitiesLeatherGoods.json');
const localitiesShoesLandings = require('./json/landingsLocalitiesShoes.json');
const localitiesRepairLandings = require('./json/landingsLocalitiesRepair.json');
const landingsAds = require('./json/landingsAds.json');
const landingsAdsV4 = require('./json/landingsAdsV4.json');
const landingsAdsPieces = require('./json/landingsAdsPieces.json');
const landingsAdsCurtains = require('./json/landingsAdsCurtains.json');
const {
  getSeo, getPath, getRepairPath, getLeatherGoodsPath, getLeatherGoodsPathV2, getLeatherGoodsSeo, getShoesPath, getShoesSeo, getRepairSeo,
  getShoesPathV2,
} = require('./services/seoLocalitiesFormatter');
const { getPostSeo } = require('./services/seoPostsFormatter');
const routesHome = require('./config/routes/routes.home');
const routesMyAccount = require('./config/routes/routes.myAccount');
const routesOrder = require('./config/routes/routes.order');

Object.keys(routesOrder).forEach((route) => {
  routesOrder[route].isRouteNotIndexedBySearchEngine = true;
});

const routes = {
  ...routesHome,
  ...routesMyAccount,
  ...routesOrder,
};

laRubriquePosts.forEach((post) => {
  routes[`LaRubrique_${post.slug}`] = {
    url: post.path,
    seo: getPostSeo(post),
  };
});

laRubriqueCategories.forEach((mainCategory) => {
  routes[`LaRubriqueCategory_${mainCategory.slug}`] = {
    url: mainCategory.path,
    seo: mainCategory.seo,
  };

  (mainCategory.categories || []).forEach((category) => {
    routes[`LaRubriqueCategory_${mainCategory.slug}${category.slug}`] = {
      url: category.path,
      seo: category.seo,
    };
    (category.subCategories || []).forEach((subCategory) => {
      (subCategory.items || []).forEach((item) => {
        routes[`LaRubriqueCategory_${mainCategory.slug + category.slug + subCategory.slug + item.slug}`] = {
          url: item.path,
          seo: item.seo,
        };
      });
    });
  });
});

landings.forEach((landing) => {
  routes[landing.slug] = {
    url: landing.path,
    seo: landing.seo,
  };
});

localitiesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getPath(landing),
    seo: getSeo(landing),
  };
});

localitiesRepairLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getRepairPath(landing),
    seo: getRepairSeo(landing),
  };
});

localitiesLeatherGoodsLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getLeatherGoodsPath(landing),
    seo: getLeatherGoodsSeo(landing),
  };
});

localitiesLeatherGoodsLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getLeatherGoodsPathV2(landing),
    seo: getLeatherGoodsSeo(landing),
  };
});

localitiesShoesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getShoesPath(landing),
    seo: getShoesSeo(landing),
  };
});

localitiesShoesLandings.forEach((landing) => {
  routes[landing.slug] = {
    url: getShoesPathV2(landing),
    seo: getShoesSeo(landing),
  };
});

landingsAds.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsV4.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsPieces.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});
landingsAdsCurtains.forEach((landing) => {
  routes[landing.slug] = { url: landing.url, isRouteNotIndexedBySearchEngine: true };
});

/**
 * Return the route url for a page of category articles
 * Returned url looks like `/la-rubrique/:category/articles/:pageNumber`
 * @param {string} categorySlug the category slug
 * @param {number} pageNumber the page number
 * @param {string} language the language of the page
 * @returns {string} the url of the page
 */
function getCategoryArticlePageUrl(categorySlug, pageNumber) {
  const { url } = routes[`LaRubriqueCategory_${categorySlug}`] || {};
  return url && `${url.replace(/\/$/, '')}/articles/${pageNumber}/`;
}

module.exports = routes;
module.exports.getCategoryArticlePageUrl = getCategoryArticlePageUrl;
